///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";

import messages from "../helpers/messages";
import Accordion from "../components/form-controls/Accordion";
import ManageUsers from "../components/admin/ManageUsers";
import SystemNotification from "../components/admin/SystemNotification";
import StrategicQuantile from "../components/admin/StrategicQuantile";

export const Admin = () => {
  const { useStrategicQuantile } = useSelector(state => state.featureFlags);

  return (
    <div className="admin">
      <div className="py-16 page-width">
        <h1 data-testid="admin" className="alpha-heading">
          {messages.admin.defaultMessage}
        </h1>
        <Accordion title={messages.manageUsers.defaultMessage}>
          <ManageUsers />
        </Accordion>
        <Accordion title={messages.sendSystemNotification.defaultMessage}>
          <SystemNotification />
        </Accordion>
        {useStrategicQuantile ? (
          <Accordion title={messages.strategicQuantile.defaultMessage}>
            <StrategicQuantile />
          </Accordion>
        ) : null}
      </div>
    </div>
  );
};

export default Admin;
